export default "__VITE_ASSET__QXAkaMXX__"